// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Bell from 'components/svg/bell.svg'
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'

// Redux:
import * as reduxSite from 'actions/site'

class HeaderNotifications extends React.Component {
	constructor( props ) {
		super( props )
	}

	handleClick = () => {
		const { dispatch, headerNotificationsIsOpen } = this.props

		dispatch( reduxSite.setHeaderNotificationsOpenState( ! headerNotificationsIsOpen ) )
	}

	handleClickTicketLink = ( e ) => {
		e.preventDefault()
		const { dispatch } = this.props

		window.dispatchEvent(
			new CustomEvent( 'openTicket', {
				detail: e.currentTarget.getAttribute( 'data-id' )
			} )
		)

		dispatch( reduxSite.setHeaderNotificationsOpenState( false ) )
	}

	render() {
		const { notificationsByTicketId, headerNotificationsIsOpen } = this.props

		if ( ! notificationsByTicketId || ! Object.keys( notificationsByTicketId ).length ) {
			return null
		}

		const wrapClass = headerNotificationsIsOpen ? '-notifications is-active' : '-notifications'
		let totalCount = 0

		{ loop( notificationsByTicketId, ( key, item ) => {
			totalCount += item.length
		} ) }

		return (
			<div className={ wrapClass }>
				<div className="-link" onClick={ this.handleClick }>
					<div className="-notifications-icon">
						<Bell />
					</div>

					<div className="-notifications-number">
						{ totalCount }
					</div>
				</div>

				<div className="-dropdown">
					{ loop( notificationsByTicketId, ( key, item ) => {
						let ticketId = key.replace( 'id_', '' )

						return (
							<section key={ key }>
								<a href={ `/?ticket_id=${ticketId}` } onClick={ this.handleClickTicketLink } data-id={ ticketId }>
									{ loopArray( item, ( key, item ) => {
										return (
											<span key={ key }>{ item.content }</span>
										)
									} ) }
								</a>
							</section>
						)
					} ) }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		headerNotificationsIsOpen: state.site.headerNotificationsIsOpen,
		notificationsByTicketId: state.tickets.notificationsByTicketId
	}
}

export default connect( mapStateToProps )( HeaderNotifications )
